import sizes from "../foundations/sizes";
var ribbonStyles = {
  parts: ["container", "link"],
  baseStyle: {
    container: {
      display: "flex",
      width: "100%",
      minHeight: sizes["16"],
      justifyContent: "center",
      alignItems: "center"
    },
    link: {
      padding: sizes["2"] + " " + sizes["3"],
      color: "inherit",
      fontWeight: "600",
      textDecoration: "none",
      textAlign: "center",
      lineHeight: "1.5",
      width: "100%",
      fontSize: "inherit"
    }
  }
};
export default ribbonStyles;
//# sourceMappingURL=ribbon.js.map